// Dependency
import React from 'react';
import { Link } from 'gatsby'
import UtilsService from '../../../services/utils.service';

// Services
import GA from '../../../services/ga.service';

// Styles
import * as styles from './cart-footer.module.scss';
import * as productStyles from './../../../templates/product/product.module.scss';

// Internationalization
import { useTranslation } from 'react-i18next';

// Assets
import iconRight from '../assets/icon-right.svg';
import iconCheck from '../assets/icon-check.svg';
import swish from "../../../images/swish.svg";
import klarna from "../../../images/Klarna_logo.svg";
import mobilePay from "../../../images/mobilepay.png";
import mvisa from "../../../images/m-visa.png";
import vipps from "../../../images/vips.svg";
import payPal from "../../../images/paypal_logo.png";
import ideal from "../../../images/ideal-logo.png";

import { useCart } from '../../../contexts/cart-context';

// Template
const CartFooter = (props) => {
  const { cart } = useCart();

  // console.log('cart: ', cart);
  // console.log('cart items: ', cart.selection.items);
  // console.log('cart props: ', props);

  // Translation Function
  const { t } = useTranslation();

  const paymentIcons = {
    se: [klarna, swish],
    dk: [mobilePay, mvisa],
    eu: [payPal, mvisa],
    no: [vipps, mvisa],
    nl: [ideal, mvisa]
  }

  return (
    cart ?
      <footer className={`${styles.cartFooter} ${props.cname}`}>
        {/* <div className={styles.cdMaintenanceText}>
            <span className="material-icons">info</span>
            <p>{t('checkout.maintenance')}</p>
        </div> */}
        <p>
          <strong>{t('miniCart.shipping')}</strong>
          {cart.selection.totals.shippingPriceAsNumber === 0
            ?
            <strong>
              {t('miniCart.free')}
            </strong>
            :
            <strong>
              {cart.selection.totals.shippingPrice}
            </strong>
          }

        </p>
        {cart.selection.discounts.anyDiscount && cart.selection.discounts.discountAsNumber !== 0 ?
          <p className={`${styles.cartFooter__sale}`}>
            <strong>{t('checkout.discount')}</strong>
            <strong>{cart.selection.discounts.discount}</strong>
          </p> : ''}
        {cart.selection.discounts.vouchers.length > 0 ? cart.selection.discounts.vouchers.map((voucher, index) => {
          return (
            <p key={index} className={`${styles.cartFooter__sale}`}>
              <strong>{voucher.description}</strong>
              <strong>{voucher.priceOff}</strong>
            </p>
          )
        }) : ''}
        <p>
          <strong>{t('checkout.tax')}</strong>
          <strong>
            <span>{cart.selection.totals.grandTotalPriceTax}</span>
          </strong>
        </p>
        <p className={`${styles.cartFooter__subtotal}`}>
          <strong>{t('miniCart.subTotal')}</strong>
          <strong>
            {/* <small>3,990 KR</small> */}
            <span>{cart.selection.totals.grandTotalPrice}</span>
          </strong>
        </p>

        <Link to={`/${UtilsService.getLocaleFromUrl().country}/checkout/`}>
          <button className={`${styles.cartFooter__btn} button`} onClick={() => GA.onCheckout(cart.selection.items, cart.selection.discounts.vouchers)}>
            {t('miniCart.continue')}
          </button>
        </Link>

      </footer> : ''
  );
};

export default CartFooter;